/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, { useEffect, useState, useCallback } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBox, faBoxes, faEdit, faHome, faPeopleArrows, faPeopleCarry, faPhone, faSearch, faUser } from "@fortawesome/free-solid-svg-icons"
import { Badge, Breadcrumb, Button, Card, Col, ProgressBar, Row, Table, Dropdown, ButtonGroup, Form, InputGroup } from '@themesberg/react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import ReceiverAction from "../../core/redux/action/ReceiverAction"
import _ from "lodash"
import PuPagination from "../../components/PuPagination"
import ReceiverDetailPage from "./ReceiverDetailPage"
import NewUserPage from "./NewUserPage"
import moment from 'moment'
import AppConfig from "../../core/config/AppConfig"
import { getUser } from "../../core/auth/authentication"
import { nameFormat, phoneFormat } from "../../core/util/General"

export default (props) => {

    const [user, setUser] = useState()
    useEffect(()=> {
        getUser().then(it=>{
            setUser(it)
        })
    }, [])

    const dispatch = useDispatch();

    const receiverRes = useSelector((state) => state.receiver);
    //const receivers = _.get(receiverRes, "receiverList.data");
    const pages = _.get(receiverRes, "receiverList.pages");
    const size = _.get(receiverRes, "receiverList.size");
    const total = _.get(receiverRes, "receiverList.total");
    const [currentPage, setCurrentPage] = useState()

    const [accountNo, setAccountNo] = useState()
    const [phone, setPhone] = useState()
    const [lastName, setLastName] = useState()
    const [firstName, setFirstName] = useState()
    const [isNew, setIsNew] = useState()

    // const [receiverId, setReceiverId] = useState('ff8080817a3704b5017a370579fe0000');
    const [receiverId, setReceiverId] = useState();
    const [isCreate, setIsCreate] = useState();

    const keyPressFunction = useCallback((event) => {
        if (event.keyCode === 13) {
            fetchData()
        }
    }, [props, accountNo, firstName, lastName, phone]);

    useEffect(() => {
        document.addEventListener("keydown", keyPressFunction, false);
        return () => {
            document.removeEventListener("keydown", keyPressFunction, false);
        };
    }, [keyPressFunction]);

    useEffect(() => {
        if (_.get(receiverRes, "receiverList.data") == undefined) {
            // fetchData()
            setCurrentPage(0)
        }
    }, [])

    useEffect(() => {
        if(currentPage != undefined) fetchData()
    }, [currentPage])

    const fetchData = () => {
        dispatch(ReceiverAction.getReceiverList({
            "input": {
                accountNo : accountNo ? `JOONAAK-${accountNo}` : undefined
                , phone
                , firstName
                , lastName
                , isNew
            },
            "token": "string"
        }, {
            size: AppConfig.pageSize,
            sort: "createdAt,DESC",
            page: currentPage
        }));
    }

    if (isCreate) {
        return <NewUserPage
            onClose={(timer) => {
                setIsCreate(undefined)
                clearInterval(timer)
            }}
        />
    }

    if (receiverId) {
        return <ReceiverDetailPage
            id={receiverId}
            onClose={(timer) => {
                setReceiverId(undefined)
                clearInterval(timer)
            }}
        />
    }

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
                <div className="d-block mb-4 mb-md-0">
                    <h4>User Managements</h4>
                    <p className="mb-0"> </p>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                    {
                        _.get(user, 'countryCode') == '855' && (<Button variant="outline-primary" size="sm" onClick={() => setIsCreate(true)}>New</Button>)
                    }                        
                        <Button variant="outline-primary" size="sm">Export</Button>
                    </ButtonGroup>
                </div>
            </div>

            <Card border="light" className="shadow-sm mb-4">
                <Card.Body className="pb-0">

                    <Row>
                        <Col xs={12} sm={6} xl={2}>
                            <Form.Group className="mb-4">
                                <Form.Label>Account No#</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faPeopleCarry} />
                                    </InputGroup.Text>
                                    <Form.Control required type="text" placeholder="Account No"
                                        onChange={(e) => setAccountNo(e.target.value == '' ? undefined : e.target.value)} />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={2}>
                            <Form.Group className="mb-4">
                                <Form.Label>Phone</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faPhone} />
                                    </InputGroup.Text>
                                    <Form.Control required type="text" placeholder="Phone"
                                        onChange={(e) => setPhone(e.target.value == '' ? undefined : e.target.value)} />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={2}>
                            <Form.Group className="mb-4">
                                <Form.Label>First Name</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faUser} />
                                    </InputGroup.Text>
                                    <Form.Control required type="text" placeholder="First Name"
                                        onChange={(e) => setFirstName(e.target.value == '' ? undefined : e.target.value)} />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={2}>
                            <Form.Group className="mb-4">
                                <Form.Label>Last Name</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faUser} />
                                    </InputGroup.Text>
                                    <Form.Control required type="text" placeholder="Last name"
                                        onChange={(e) => setLastName(e.target.value == '' ? undefined : e.target.value)} />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={2}>
                        <Form.Group className="mb-3">
                            <Form.Label>Active User</Form.Label>
                            <InputGroup>
                            <Form.Select onChange={(e) => {
                                //console.log('>value', e.target.value)                        
                                setIsNew(e.target.value == "--All--" ? undefined : e.target.value)
                            }}>
                                <option>--All--</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>                                      
                            </Form.Select>
                            </InputGroup>
                        </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} xl={2}>
                            <Form.Group className="mb-4 float-end" style={{ paddingTop: 30 }}>
                                <Button onClick={fetchData}><FontAwesomeIcon icon={faSearch} /> Search</Button>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Table responsive className="table-centered table-nowrap rounded mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th className="border-0">#</th>
                                <th className="border-0">Account No#</th>
                                {
                                    _.get(user, 'countryCode') == '855' && (<th className="border-0">Action</th>)
                                }
                                
                                <th className="border-0">Name</th>
                                <th className="border-0">Phone</th>
                                {/* <th className="border-0">Zip Code</th> */}
                                <th className="border-0">Postal Code</th>                                
                                <th className="border-0">
                                    <FontAwesomeIcon icon={faBox} />
                                </th>
                                <th className="border-0">Created Date</th>
                                <th className="border-0">App User</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                //receivers && receivers.map()
                                _.get(receiverRes, 'receiverList.data') && _.get(receiverRes, 'receiverList.data').map((item, index) => {
                                    console.log(">>item", item)
                                    return (
                                        <tr>
                                            <td>{(index + 1) + (AppConfig.pageSize * (currentPage ?? 0))}</td>
                                            <td>{_.get(item, 'accountNo', '')}</td>
                                            {
                                                _.get(user, 'countryCode') == '855' && (
                                                    <td>
                                                        <Button variant="transparent" size="sm" className="ms-3 mb-0 fs-10" onClick={() => setReceiverId(item.id)}><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                                    </td>
                                                )
                                            }
                                            
                                            <td>{ nameFormat(item) }</td>
                                            <td>{ phoneFormat(item) }</td>
                                            <td>{_.get(item, 'postCode', '')}</td>

                                            <td>{_.get(item, 'waybillCount', '_')}</td>
                                            
                                            <td>{moment(_.get(item, 'createdAt')).format('DD MM,YYYY HH:mma')}</td>

                                            <td>{_.get(item, 'expressId') ?
                                                <Badge pill bg='success' className="badge-sm ms-3 mb-0 fs-10">Yes</Badge> :
                                                <Badge pill bg='danger' className="badge-sm ms-3 mb-0 fs-10">No</Badge>
                                            }</td>
                                            
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </Card.Body>
                <Card.Footer>
                    <PuPagination size={size} total={total} currentPage={currentPage} totalPage={pages} onChange={setCurrentPage} />
                </Card.Footer>
            </Card>
        </>
    )
}

const ReceiverTable = () => {

    //const TableRow = (props) => {const { id, source, sourceIcon, sourceIconColor, sourceType, category, rank, trafficShare, change } = props;



}